import { Component, OnInit } from '@angular/core';
import {  PBApi, UserApi, AppUser, SystemsApi } from '../core/api.gen';
import { ToastService } from '../core';
import { AuthService } from '../core/auth.service';
import { LoaderService } from 'src/app/core/loader.service';
import { saveAs } from 'file-saver';
import { DocumentUploadService } from '../core/document-upload.service';
import { DialogService } from 'src/app/core/dialog.service';

@Component({
  selector: 'eos-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  currentUser: AppUser;
  userDetails: any;
  hasSysAccess: any;
  constructor(private pbAPI: PBApi, private toast: ToastService, private systemsAPI: SystemsApi, private authService: AuthService,
    private userAPI: UserApi,private loader: LoaderService,private fileUploadService: DocumentUploadService
    ,private dialog: DialogService) { }
  

  ngOnInit() {
    this.currentUser = this.authService.ActiveUser;
    this.getUserDetails();
  }

  createCandidateActivities(){
    this.pbAPI.createCandidateActivities().subscribe((resp) => {
      this.toast.success("Activities created!");});
  }

  updateEmail() {
    this.dialog.showConfirmationBox('Copy and download email templates',
          'Do you want to copy and download all the emails templates',
          () => {
            this.loader.show();
            this.systemsAPI.copyEmailTemplatesToAnotherFolder().subscribe(
              (resp)=>{
                if(resp.statusCode==200){
                  this.fileUploadService.downloadAllEmailTemplate().subscribe((resp) => {
                    saveAs(resp, "emailTemplates.zip");
                })
                }
              },
              err => { 
                this.loader.clear(); 
                this.toast.error("Some error occured");
               },
               ()=>{this.loader.clear();});
              }
            )   
  }

  getUserDetails() {
    this.userAPI.getUserDetails(this.currentUser.userId).subscribe(
      resp => {
        this.userDetails = resp;
        let userclaims = this.userDetails.userClaims;
        this.hasSysAccess = userclaims.some(x => x.type == 'Claim' && x.value == 'SYS');
      }
    );
  }

}
